import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const FilterToolbar = ({ 
  filters, 
  onFilterChange, 
  onClearFilters, 
  resultCount = 0 
}) => {
  const platformOptions = [
    { value: 'all', label: 'All Platforms' },
    { value: 'facebook', label: 'Facebook' },
    { value: 'twitter', label: 'Twitter' },
    { value: 'linkedin', label: 'LinkedIn' },
    { value: 'instagram', label: 'Instagram' },
    { value: 'website', label: 'Website' }
  ];

  const riskLevelOptions = [
    { value: 'all', label: 'All Risk Levels' },
    { value: 'high', label: 'High Risk' },
    { value: 'medium', label: 'Medium Risk' },
    { value: 'low', label: 'Low Risk' }
  ];

  const statusOptions = [
    { value: 'all', label: 'All Status' },
    { value: 'pending', label: 'Pending Review' },
    { value: 'approved', label: 'Approved' },
    { value: 'flagged', label: 'Flagged' }
  ];

  const hasActiveFilters = () => {
    return filters?.platform !== 'all' || 
           filters?.riskLevel !== 'all' || 
           filters?.status !== 'all' || 
           filters?.dateRange || 
           filters?.search;
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 mb-6">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between space-y-4 lg:space-y-0">
        {/* Filter Controls */}
        <div className="flex flex-col sm:flex-row sm:items-center space-y-3 sm:space-y-0 sm:space-x-4">
          <div className="flex items-center space-x-3">
            <Select
              options={platformOptions}
              value={filters?.platform}
              onChange={(value) => onFilterChange('platform', value)}
              placeholder="Platform"
              className="w-40"
            />
            
            <Select
              options={riskLevelOptions}
              value={filters?.riskLevel}
              onChange={(value) => onFilterChange('riskLevel', value)}
              placeholder="Risk Level"
              className="w-40"
            />
            
            <Select
              options={statusOptions}
              value={filters?.status}
              onChange={(value) => onFilterChange('status', value)}
              placeholder="Status"
              className="w-40"
            />
          </div>

          <div className="flex items-center space-x-3">
            <Input
              type="search"
              placeholder="Search content..."
              value={filters?.search || ''}
              onChange={(e) => onFilterChange('search', e?.target?.value)}
              className="w-64"
            />
            
            <Input
              type="date"
              value={filters?.dateRange || ''}
              onChange={(e) => onFilterChange('dateRange', e?.target?.value)}
              className="w-40"
            />
          </div>
        </div>

        {/* Results & Actions */}
        <div className="flex items-center justify-between sm:justify-end space-x-4">
          <div className="flex items-center space-x-2 text-sm text-muted-foreground">
            <Icon name="Filter" size={16} />
            <span>{resultCount} results</span>
          </div>
          
          {hasActiveFilters() && (
            <Button
              variant="outline"
              size="sm"
              iconName="X"
              iconSize={14}
              onClick={onClearFilters}
            >
              Clear Filters
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default FilterToolbar;